// Translations
import form from '../sections/form/translations/de'

// Translation: Login > Landing (German)
export default Object.freeze({
	sections: { form }
})
